import { ref, onMounted, onUnmounted } from "vue";

export function useBootstrapModal(modalId: string) {
  const modalInstance = ref<any | null>(null);

  onMounted(async () => {

  });

  const openModal = async () => {

    
    if (import.meta.client) {
      const bootstrap = await import("bootstrap"); // تحميل Bootstrap فقط على الكلاينت
      
      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        modalInstance.value = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
      }
    }

    modalInstance.value?.show();
  };

  const closeModal = async () => {

    if (import.meta.client) {
      const bootstrap = await import("bootstrap"); // تحميل Bootstrap فقط على الكلاينت
      
      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        modalInstance.value = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
      }
    }

    if (modalInstance.value) {
      modalInstance.value.hide();

      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        modalElement.classList.remove("show");
        modalElement.setAttribute("aria-hidden", "true");
        modalElement.style.display = "none";

        // إزالة الخلفية (Backdrop)
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
          backdrop.remove();
        }
      }
    } else {
      console.error("❌ Modal instance is null, unable to hide modal.");
    }
  };

  onUnmounted(() => {
    modalInstance.value = null;
  });

  return { openModal, closeModal };
}
